import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { FightingSection } from '../components/FightingSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { BlueprintDetails } from '../components/BlueprintDetails';
import { PhasesTimeline } from '../components/PhasesTimeline';
import { TransformationSection } from '../components/TransformationSection';
import { PricingSection } from '../components/PricingSection';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  return <div className="min-h-screen bg-black text-white selection:bg-orange-500 selection:text-white" data-id="element-147">
      <UrgencyBar data-id="element-148" />
      <main data-id="element-149">
        <HeroSection data-id="element-150" />
        <FightingSection data-id="element-151" />
        <PainSection data-id="element-152" />
        <SolutionSection data-id="element-153" />
        <BlueprintDetails data-id="element-154" />
        <PhasesTimeline data-id="element-155" />
        <TransformationSection data-id="element-156" />
        <PricingSection data-id="element-157" />
      </main>

      <footer className="bg-black py-8 text-center text-gray-800 text-sm border-t border-gray-900" data-id="element-158">
        <p className="mb-2" data-id="element-159">
          This site is not a part of the Facebook website or Facebook Inc.
          Additionally, this site is NOT endorsed by Facebook in any way.
          FACEBOOK is a trademark of FACEBOOK, Inc.
        </p>
        <p data-id="element-160">
          © {new Date().getFullYear()} Feline Harmony Blueprint. All rights
          reserved.
        </p>
      </footer>

      <PurchasePopup data-id="element-161" />
    </div>;
}